import { styled } from '@styledComponents';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { Flex } from '@components/Flex';
import { TextPairing } from '@components/TextPairing';
import { CloudImage } from '@components/CloudImage';

export const JoyButtonTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 311px;
    ${themeMediaQuery('xl')} {
      max-width: 520px;
    }
    ${themeMediaQuery('below_sm')} {
      width: 311px;
    }
  }
  .text-pairing-body {
    max-width: 320px;
    ${themeMediaQuery('xl')} {
      max-width: 520px;
    }
    ${themeMediaQuery('below_sm')} {
      width: 300px;
    }
  }
  ${themeMediaQuery('below_sm')} {
    margin-top: ${themeSpace(6)};
    align-items: center;
    text-align: center;
  }
  @media (max-width: 320px) {
    margin-top: ${themeSpace(-5)};
  }
`;

export const StyledLeftImageWrapper = styled(Flex)`
  position: relative;
  ${themeMediaQuery('below_sm')} {
    justify-content: center;
    min-height: 350px;
  }
  ${themeMediaQuery('sm')} {
    width: 100%;
    justify-content: flex-end;
  }
  ${themeMediaQuery('md')} {
    width: max-content;
    justify-content: unset;
  }
`;

export const BrowserButtonShapeImage = styled(CloudImage)`
  max-width: 476px;
  max-height: 561px;
  ${themeMediaQuery('below_sm')} {
    max-width: 380px;
  }
  @media (max-width: 320px) {
    max-width: 326px;
    position: absolute;
    left: -50px;
  }
`;

export const BottomWave = styled(CloudImage)`
  width: 100%;
  position: absolute;
`;
